import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProjectSectionListRequest } from '../models/project/project-section-list-request.model';
import { ProjectSection } from '../models/project/project-section.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { UpdateProjectSectionStage } from '../models/project/update-project-section-stage.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectSectionService extends RequestService<ProjectSection> {
  static PATH = '/project/section';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ProjectSectionService.PATH, globalService.debugUrl);
  }

  listSimple(req: ProjectSectionListRequest) {
    return this.httpClient.post<ProjectSection[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ProjectSectionService.PATH}/listSimple`,
      req
    );
  }

  updateStage(req: UpdateProjectSectionStage) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ProjectSectionService.PATH}/updateStage`,
      req
    );
  }
}
